const auth = {
	LOGIN: "LOGIN",
	LOGOUT: "LOGOUT",
	SET_USER: "SET_USER",
	PERMISSION_USER: "PERMISSION_USER",

	login: (data) => {
		localStorage.setItem("isLogin", true);
		localStorage.setItem("token", data.token);

		return {
			type: auth.LOGIN,
			isLogin: true,
			token: data.token,
		};
	},

	permissions: (data) => {
		localStorage.setItem("permissions", data);

		return {
			type: auth.PERMISSION_USER,
			permissions: data,
		};
	},

	setuser: (data) => {
		// console.log("dadaada", data);
		return {
			type: auth.SET_USER,
			user: data,
		};
	},

	logout: () => {
		localStorage.removeItem("isLogin");
		localStorage.removeItem("token");
		localStorage.removeItem("permissions");
		document.cookie = `token= ;SameSite=strict;max-age=0`;

		return {
			type: auth.LOGOUT,
			isLogin: false,
			token: null,
			permissions: [],
			user: {},
		};
	},
};

export default auth;
